import React from "react";

/* Form & Form Validation */
import * as Yup from "yup";

import { BasicForm, _filter } from "../../../../core/components/form";

import { Form, Select, Checkbox, DatePicker } from "formik-antd";

import { jobStatus } from "../../../../components/job/status";
import { purchaseOrderStatus } from "../../../../components/purchaseOrder/status";
import { invoiceStatus } from "../../../../components/invoice/status";

import {
    CRON_REPORT_TYPE,
    CRON_REPORT_SUBTYPE_CLIENT,
    CRON_REPORT_SUBTYPE_VENDOR,
    CRON_REPORT_SUBTYPE_JOB,
    CRON_REPORT_SUBTYPE_QUOTE,
    CRON_REPORT_SUBTYPE_PURCHASE_ORDER,
    CRON_REPORT_SUBTYPE_INVOICE,
    CRON_REPORT_SUBTYPE_PAYMENT,
    CRON_REPORT_SUBTYPE_QA,
} from "../../const";

const LoginSchema = Yup.object().shape({
    subtype: Yup.string().required("Cannot be blank."),
    from: Yup.date().when("subtype", {
        is: (type) =>
            type === CRON_REPORT_SUBTYPE_JOB ||
            type === CRON_REPORT_SUBTYPE_QUOTE ||
            type === CRON_REPORT_SUBTYPE_PURCHASE_ORDER ||
            type === CRON_REPORT_SUBTYPE_INVOICE ||
            type === CRON_REPORT_SUBTYPE_QA ||
            type === CRON_REPORT_SUBTYPE_PAYMENT,
        then: Yup.date().required("Cannot be blank.").typeError("Must be a date"),
    }),
    to: Yup.date()
        .when(["subtype"], {
            is: (type) =>
                type === CRON_REPORT_SUBTYPE_JOB ||
                type === CRON_REPORT_SUBTYPE_QUOTE ||
                type === CRON_REPORT_SUBTYPE_PURCHASE_ORDER ||
                type === CRON_REPORT_SUBTYPE_INVOICE ||
                type === CRON_REPORT_SUBTYPE_QA ||
                type === CRON_REPORT_SUBTYPE_PAYMENT,
            then: Yup.date().required("Cannot be blank.").typeError("Must be a date"),
        })
        .when("from", {
            is: (from) => from,
            then: Yup.date().min(Yup.ref("from"), "End time cannot be before start time"),
        }),
});

const Formulario = (props) => {
    const _goBack = () => {
        props.history.goBack();
    };

    const _initialForm = () => {
        return {
            /* se puede elminar el type, no lo estoy tomando */
            type: CRON_REPORT_TYPE,
            subtype: "",
            from: "",
            to: "",
        };
    };

    const resetVendorValues = (setFieldValue) => {
        setFieldValue("active", "");
        setFieldValue("workWithMT", "");
        setFieldValue("workOnHolidays", "");
        setFieldValue("readyToWork", "");
        setFieldValue("campaign", "");
        setFieldValue("priority", "");
        setFieldValue("tag", "");
    };

    const resetJobValues = (setFieldValue) => {
        setFieldValue("from", "");
        setFieldValue("to", "");
        setFieldValue("client", "");
        setFieldValue("status", "");
        setFieldValue("unpaid", "");
    };

    const resetQuoteValues = (setFieldValue) => {
        setFieldValue("from", "");
        setFieldValue("to", "");
        setFieldValue("client", "");
        setFieldValue("status", "");
        setFieldValue("unpaid", "");
    };

    const resetPurchaseOrderValues = (setFieldValue) => {
        setFieldValue("from", "");
        setFieldValue("to", "");
        setFieldValue("vendor", "");
        setFieldValue("status", "");
    };

    const resetValues = (setFieldValue, subtype) => {
        if (subtype === CRON_REPORT_SUBTYPE_JOB || subtype === CRON_REPORT_SUBTYPE_PURCHASE_ORDER) {
            resetVendorValues(setFieldValue);
            resetQuoteValues(setFieldValue);
        } else if (subtype === CRON_REPORT_SUBTYPE_QUOTE) {
            resetVendorValues(setFieldValue);
            resetJobValues(setFieldValue);
        } else if (subtype === CRON_REPORT_SUBTYPE_VENDOR) {
            resetJobValues(setFieldValue);
        } else if (subtype === CRON_REPORT_SUBTYPE_CLIENT) {
            resetVendorValues(setFieldValue);
            resetJobValues(setFieldValue);
        }
    };

    return (
        <BasicForm
            onPressBack={_goBack}
            titulo="GENERATE REPORT"
            initialValues={_initialForm()}
            validationSchema={LoginSchema}
            onSubmit={props.handleSubmit}
            render={({ values, setFieldValue }) => (
                <>
                    {/* se puede sacar, no se toma en el back */}
                    <Form.Item name="type" hidden></Form.Item>

                    <Form.Item label="Report" name="subtype" hasFeedback={true} showValidateSuccess={true} required>
                        <Select
                            placeholder="Report"
                            name="subtype"
                            showSearch
                            onSelect={(subtype) => resetValues(setFieldValue, subtype)}
                        >
                            <Select.Option value=""></Select.Option>
                            <Select.Option value={CRON_REPORT_SUBTYPE_JOB}>{CRON_REPORT_SUBTYPE_JOB}</Select.Option>
                            <Select.Option value={CRON_REPORT_SUBTYPE_QUOTE}>{CRON_REPORT_SUBTYPE_QUOTE}</Select.Option>
                            <Select.Option value={CRON_REPORT_SUBTYPE_CLIENT}>
                                {CRON_REPORT_SUBTYPE_CLIENT}
                            </Select.Option>
                            <Select.Option value={CRON_REPORT_SUBTYPE_VENDOR}>
                                {CRON_REPORT_SUBTYPE_VENDOR}
                            </Select.Option>
                            <Select.Option value={CRON_REPORT_SUBTYPE_PURCHASE_ORDER}>
                                {CRON_REPORT_SUBTYPE_PURCHASE_ORDER}
                            </Select.Option>

                            <Select.Option value={CRON_REPORT_SUBTYPE_INVOICE}>
                                {CRON_REPORT_SUBTYPE_INVOICE}
                            </Select.Option>
                            <Select.Option value={CRON_REPORT_SUBTYPE_PAYMENT}>
                                {CRON_REPORT_SUBTYPE_PAYMENT}
                            </Select.Option>
                            <Select.Option value={CRON_REPORT_SUBTYPE_QA}>{CRON_REPORT_SUBTYPE_QA}</Select.Option>
                        </Select>
                    </Form.Item>

                    {values.subtype === CRON_REPORT_SUBTYPE_JOB && (
                        <>
                            <Form.Item label="From" name="from" hasFeedback={true} showValidateSuccess={true} required>
                                <DatePicker name="from" />
                            </Form.Item>

                            <Form.Item label="To" name="to" hasFeedback={true} showValidateSuccess={true} required>
                                <DatePicker name="to" />
                            </Form.Item>

                            <Form.Item label="Client" name="client">
                                <Select
                                    placeholder="Client"
                                    name="client"
                                    showSearch
                                    options={props.clients}
                                    filterOption={_filter}
                                    allowClear
                                />
                            </Form.Item>

                            <Form.Item name="status" label="Status">
                                <Select
                                    showSearch
                                    mode="multiple"
                                    name="status"
                                    placeholder="Filter by Status"
                                    allowClear
                                    options={jobStatus}
                                />
                            </Form.Item>
                            <Form.Item name="unpaid" label="Unpaid">
                                <Select name="unpaid" placeholder="All" allowClear>
                                    <Select.Option value="1">Yes</Select.Option>
                                    <Select.Option value="0">No</Select.Option>
                                </Select>
                            </Form.Item>
                        </>
                    )}

                    {values.subtype === CRON_REPORT_SUBTYPE_QUOTE && (
                        <>
                            <Form.Item label="From" name="from" hasFeedback={true} showValidateSuccess={true} required>
                                <DatePicker name="from" />
                            </Form.Item>

                            <Form.Item label="To" name="to" hasFeedback={true} showValidateSuccess={true} required>
                                <DatePicker name="to" />
                            </Form.Item>

                            <Form.Item label="Client" name="client">
                                <Select
                                    placeholder="Client"
                                    name="client"
                                    showSearch
                                    options={props.clients}
                                    filterOption={_filter}
                                    allowClear
                                />
                            </Form.Item>
                        </>
                    )}

                    {values.subtype === CRON_REPORT_SUBTYPE_QA && (
                        <>
                            <Form.Item label="From" name="from" hasFeedback={true} showValidateSuccess={true} required>
                                <DatePicker name="from" />
                            </Form.Item>

                            <Form.Item label="To" name="to" hasFeedback={true} showValidateSuccess={true} required>
                                <DatePicker name="to" />
                            </Form.Item>

                            <Form.Item label="Vendor" name="vendor">
                                <Select
                                    placeholder="Vendor"
                                    name="vendor"
                                    showSearch
                                    options={props.vendors}
                                    filterOption={_filter}
                                    allowClear
                                />
                            </Form.Item>
                        </>
                    )}

                    {values.subtype === CRON_REPORT_SUBTYPE_VENDOR && (
                        <>
                            <Form.Item name="active" label="Active">
                                <Select name="active" placeholder="All" allowClear>
                                    <Select.Option value="1">Yes</Select.Option>
                                    <Select.Option value="0">No</Select.Option>
                                </Select>
                            </Form.Item>
                            <Form.Item name="workWithMT" label="Work with MT">
                                <Select name="workWithMT" placeholder="All" allowClear>
                                    <Select.Option value="1">Yes</Select.Option>
                                    <Select.Option value="0">No</Select.Option>
                                </Select>
                            </Form.Item>
                            <Form.Item name="workOnHolidays" label="Work on Holidays">
                                <Select name="workOnHolidays" placeholder="All" allowClear>
                                    <Select.Option value="1">Yes</Select.Option>
                                    <Select.Option value="0">No</Select.Option>
                                </Select>
                            </Form.Item>
                            <Form.Item name="readyToWork" label="Ready to Work">
                                <Select name="readyToWork" placeholder="All" allowClear>
                                    <Select.Option value="1">Yes</Select.Option>
                                    <Select.Option value="0">No</Select.Option>
                                </Select>
                            </Form.Item>
                            <Form.Item label="Campaign" name="campaign">
                                <Select
                                    placeholder="Campaign"
                                    name="campaign"
                                    showSearch
                                    options={props.campaigns}
                                    filterOption={_filter}
                                    allowClear
                                />
                            </Form.Item>
                            <Form.Item label="Tag" name="tag">
                                <Select
                                    placeholder="Tag"
                                    name="tag"
                                    showSearch
                                    options={props.tags}
                                    filterOption={_filter}
                                    allowClear
                                />
                            </Form.Item>
                            <Form.Item label="Priority" name="priority">
                                <Select
                                    placeholder="Priority"
                                    name="priority"
                                    showSearch
                                    options={props.priorities}
                                    filterOption={_filter}
                                    allowClear
                                />
                            </Form.Item>
                        </>
                    )}
                    {values.subtype === CRON_REPORT_SUBTYPE_PURCHASE_ORDER && (
                        <>
                            <Form.Item label="From" name="from" hasFeedback={true} showValidateSuccess={true} required>
                                <DatePicker name="from" />
                            </Form.Item>

                            <Form.Item label="To" name="to" hasFeedback={true} showValidateSuccess={true} required>
                                <DatePicker name="to" />
                            </Form.Item>

                            <Form.Item label="Vendor" name="vendor">
                                <Select
                                    placeholder="Vendor"
                                    name="vendor"
                                    showSearch
                                    options={props.vendors}
                                    filterOption={_filter}
                                    allowClear
                                />
                            </Form.Item>
                            <Form.Item name="status" label="Status">
                                <Select
                                    showSearch
                                    mode="multiple"
                                    name="status"
                                    placeholder="Filter by Status"
                                    allowClear
                                    options={purchaseOrderStatus}
                                />
                            </Form.Item>
                        </>
                    )}
                    {values.subtype === CRON_REPORT_SUBTYPE_INVOICE && (
                        <>
                            <Form.Item label="From" name="from" hasFeedback={true} showValidateSuccess={true} required>
                                <DatePicker name="from" />
                            </Form.Item>

                            <Form.Item label="To" name="to" hasFeedback={true} showValidateSuccess={true} required>
                                <DatePicker name="to" />
                            </Form.Item>

                            <Form.Item label="Vendor" name="vendor">
                                <Select
                                    placeholder="Vendor"
                                    name="vendor"
                                    showSearch
                                    options={props.vendors}
                                    filterOption={_filter}
                                    allowClear
                                />
                            </Form.Item>
                            <Form.Item name="status" label="Status">
                                <Select
                                    showSearch
                                    mode="multiple"
                                    name="status"
                                    placeholder="Filter by Status"
                                    allowClear
                                    options={invoiceStatus}
                                />
                            </Form.Item>
                        </>
                    )}
                    {values.subtype === CRON_REPORT_SUBTYPE_PAYMENT && (
                        <>
                            <Form.Item label="From" name="from" hasFeedback={true} showValidateSuccess={true} required>
                                <DatePicker name="from" />
                            </Form.Item>

                            <Form.Item label="To" name="to" hasFeedback={true} showValidateSuccess={true} required>
                                <DatePicker name="to" />
                            </Form.Item>

                            <Form.Item label="Vendor" name="vendor">
                                <Select
                                    placeholder="Vendor"
                                    name="vendor"
                                    showSearch
                                    options={props.vendors}
                                    filterOption={_filter}
                                    allowClear
                                />
                            </Form.Item>
                        </>
                    )}
                </>
            )}
        />
    );
};

export default Formulario;
